var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "MountKits" } },
    [
      _c(
        "b-row",
        { staticClass: "mb-3", attrs: { "align-v": "center" } },
        [
          _c(
            "b-col",
            { staticClass: "text-center", attrs: { md: "6", lg: "4" } },
            [
              _c("picture", [
                _c("source", {
                  attrs: {
                    srcset: require("@/img/site/mount-kits.jpg?format=webp"),
                    type: "image/webp",
                  },
                }),
                _c("source", {
                  attrs: {
                    srcset: require("@/img/site/mount-kits.jpg"),
                    type: "image/jpeg",
                  },
                }),
                _c("img", {
                  staticStyle: { "max-height": "350px" },
                  attrs: { src: require("@/img/site/mount-kits.jpg") },
                }),
              ]),
            ]
          ),
          _c("b-col", [
            _c("p", { staticClass: "text-center" }, [
              _vm._v(
                "Our Photo Mount & Picture Frame mount Kits offer superb value for money for Artists, Photographers and Crafters. We supply quality precision-cut Larson-Juhl mount boards along with a Larson-Juhl backing board and a cellophane bag to fit. \nThese kits enable you to retail your artwork easily. \nOur prices are very low, plus the more you buy the more you save!"
              ),
            ]),
            _c(
              "p",
              { staticClass: "lead text-center", attrs: { id: "min-price" } },
              [_vm._v("From just £" + _vm._s(_vm.minPrice) + " per kit")]
            ),
            _c("p", { staticClass: "lead text-center mb-0" }, [
              _vm._v(
                "A kit contains a piece of cut to size mountboard, along with a piece of cut to size Larson-Juhl backing board and also a self-sealant cellophane bag."
              ),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { lg: "7" } },
            [
              _c("h4", { staticClass: "mb-3" }, [_vm._v("Choose your size:")]),
              _c("b-form-radio-group", {
                staticClass: "mb-3",
                attrs: {
                  options: _vm.initSizeTypeOptions,
                  buttons: "",
                  "button-variant": "brand",
                  size: "lg",
                },
                model: {
                  value: _vm.initSizeType,
                  callback: function ($$v) {
                    _vm.initSizeType = $$v
                  },
                  expression: "initSizeType",
                },
              }),
              _vm.initSizeType == "artwork"
                ? _c("mount-kit-size-selector", {
                    key: "artwork-size-selector",
                    attrs: { "size-type": "artwork" },
                    model: {
                      value: _vm.selectedInitSize,
                      callback: function ($$v) {
                        _vm.selectedInitSize = $$v
                      },
                      expression: "selectedInitSize",
                    },
                  })
                : _c("mount-kit-size-selector", {
                    key: "frame-size-selector",
                    attrs: { "size-type": "frame" },
                    model: {
                      value: _vm.selectedInitSize,
                      callback: function ($$v) {
                        _vm.selectedInitSize = $$v
                      },
                      expression: "selectedInitSize",
                    },
                  }),
              _c("h4", { staticClass: "mb-3 mt-5" }, [
                _vm._v("Choose your mount design:"),
              ]),
              _vm.initSizeType == "artwork"
                ? _c("mount-kit-design-selector", {
                    key: "artwork-mount-designer",
                    attrs: {
                      size: _vm.selectedInitSize,
                      "board-code": _vm.selectedBoard
                        ? _vm.selectedBoard.stock_lookup_sku
                        : "8001",
                      "size-type": "artwork",
                    },
                    on: { change: _vm.onDesignerReady },
                    model: {
                      value: _vm.selectedSecSize,
                      callback: function ($$v) {
                        _vm.selectedSecSize = $$v
                      },
                      expression: "selectedSecSize",
                    },
                  })
                : _c("mount-kit-design-selector", {
                    key: "frame-mount-designer",
                    attrs: {
                      size: _vm.selectedInitSize,
                      "board-code": _vm.selectedBoard
                        ? _vm.selectedBoard.stock_lookup_sku
                        : "8001",
                      "size-type": "frame",
                      "min-price": _vm.minPrice,
                    },
                    on: { change: _vm.onDesignerReady },
                    model: {
                      value: _vm.selectedSecSize,
                      callback: function ($$v) {
                        _vm.selectedSecSize = $$v
                      },
                      expression: "selectedSecSize",
                    },
                  }),
              _c("h4", { staticClass: "mb-3 mt-5" }, [
                _vm._v("Choose your mount colour:"),
              ]),
              _c("mountboard-colours", {
                model: {
                  value: _vm.selectedBoard,
                  callback: function ($$v) {
                    _vm.selectedBoard = $$v
                  },
                  expression: "selectedBoard",
                },
              }),
              _c(
                "b-row",
                { staticClass: "mt-4" },
                [
                  _c(
                    "b-col",
                    { staticClass: "mb-3", attrs: { lg: "6" } },
                    [
                      _c("h4", [_vm._v("Place your order")]),
                      _c("p", [
                        _vm._v(
                          "A kit contains a piece of cut to size mountboard, along with a piece of cut to size Larson-Juhl backing board and also a self-sealant cellophane bag."
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "All sizes quoted are 'to fit' an item of that size, therefore the actual aperture is slightly smaller "
                        ),
                        _c("strong", [_vm._v("(approx 3mm on all sides)")]),
                        _vm._v(
                          " than the quoted size to ensure your item does not fall through."
                        ),
                      ]),
                      _c(
                        "b-row",
                        { staticClass: "justify-content-end" },
                        [
                          _c(
                            "b-col",
                            { attrs: { sm: "12", md: "auto" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Quantity:",
                                    "label-cols-sm": "5",
                                    "label-size": "lg",
                                    "label-align-sm": "right",
                                    "invalid-feedback":
                                      "Please enter a quantity larger than 0",
                                    state: _vm.isQuantityValid,
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      size: "lg",
                                      type: "number",
                                      number: "",
                                      step: "1",
                                      min: "1",
                                    },
                                    model: {
                                      value: _vm.quantity,
                                      callback: function ($$v) {
                                        _vm.quantity = $$v
                                      },
                                      expression: "quantity",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "auto" } },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    size: "lg",
                                    variant: "success",
                                    disabled: _vm.loading,
                                  },
                                  on: { click: _vm.addToCart },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons mr-2" },
                                    [_vm._v("shopping_cart")]
                                  ),
                                  _vm._v(
                                    "Add to Cart (£" +
                                      _vm._s(_vm.priceBreakdown.total_price) +
                                      ")"
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { staticClass: "mb-3", attrs: { lg: "6" } },
                    [
                      _c("h5", [_vm._v("Volume Discounts")]),
                      _c("p", { staticClass: "mb-1" }, [
                        _vm._v("The more you buy, the more you save!"),
                      ]),
                      _c("discounts-breakdown", {
                        attrs: {
                          "sku-prefix": "MK",
                          "item-type": "Mount",
                          price: _vm.priceBreakdown.ex_vat_base_unit_price,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("b-col", { staticClass: "text-center mb-3" }, [
            _c(
              "div",
              { staticClass: "sticky-top pt-3" },
              [
                _c("mount-visualisation", {
                  attrs: {
                    board: _vm.selectedBoard,
                    "external-size": _vm.externalSize,
                    "aperture-size": _vm.apertureSize,
                  },
                }),
                _c("p", { staticClass: "text-center mb-2 mt-3" }, [
                  _vm._v(
                    "We also offer picture mounts in custom sizes up to 815x1120mm."
                  ),
                ]),
                _c(
                  "b-button",
                  { staticClass: "btn-brand", attrs: { href: _vm.bespokeUrl } },
                  [_vm._v("Configure and buy a custom sized mount")]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }